export * from './api.service';
export * from './backend.service';


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/http/index.ts